import * as React from 'react';
import classnames from 'classnames';
import { H2 } from '@grandvisionhq/iris-ui';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import '../../../../types/product.js';
import { SUBSCRIPTION_PURCHASE, SINGLE_PURCHASE } from '../../../../types/purchase-types.js';
import { isInStoreSubscriptionPurchase, isSubscriptionPurchase } from '../../../../types/typeguards.js';
import '../../../../context/ProductContext.js';
import { useCmsData } from '../../../../context/CmsContext.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import { pushPurchaseTypeSelectionEvent } from '../../../Analytics/events/subscription-events.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import { PurchaseTypeSelectionBox } from './components/PurchaseTypeSelectionBox.js';

const getBadgePrice = (purchaseTypeKey, purchaseTypePrices)=>{
    if (isSubscriptionPurchase(purchaseTypeKey)) {
        return purchaseTypePrices[SUBSCRIPTION_PURCHASE];
    }
    if (isInStoreSubscriptionPurchase(purchaseTypeKey)) {
        return undefined;
    }
    return purchaseTypePrices[SINGLE_PURCHASE];
};
const PurchaseTypeSelectionBoxes = /*#__PURE__*/ React.memo(({ className , onSelection , purchaseTypePrices , selectedPurchaseType , isAvailableForInStoreSubscription , subscriptionTypeAllowed  })=>{
    const { purchaseTypeDocument  } = useCmsData();
    const handleOnSelection = React.useCallback((purchaseTypeKey)=>{
        onSelection(purchaseTypeKey);
        pushPurchaseTypeSelectionEvent(purchaseTypeKey);
    }, []);
    if (!purchaseTypeDocument) {
        return null;
    }
    const { purchaseTypes , title  } = purchaseTypeDocument;
    const filteredPurchaseTypes = purchaseTypes.filter((type)=>{
        // Remove in-store subscription if regular subscription should be shown
        if (!isAvailableForInStoreSubscription && isInStoreSubscriptionPurchase(type.key)) {
            return false;
        }
        // Remove subscription type if not allowed
        if (!subscriptionTypeAllowed && isSubscriptionPurchase(type.key)) {
            return false;
        }
        return true;
    });
    // Do not show the purchase type selection boxes if there is only one purchase type
    if (filteredPurchaseTypes.length < 2) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('purchase-type-selection-boxes', className)
    }, title && /*#__PURE__*/ React.createElement(H2, {
        className: "purchase-type-selection-boxes__title",
        variant: "heading-smallest"
    }, title), /*#__PURE__*/ React.createElement("fieldset", {
        "aria-label": title
    }, filteredPurchaseTypes.map((purchaseType)=>{
        const badgePrice = getBadgePrice(purchaseType.key, purchaseTypePrices);
        return /*#__PURE__*/ React.createElement(PurchaseTypeSelectionBox, {
            key: purchaseType.key,
            value: purchaseType.key,
            "data-t": purchaseType.key,
            title: purchaseType.title,
            description: purchaseType.description,
            onChange: handleOnSelection,
            isSelected: purchaseType.key === selectedPurchaseType,
            badgePrice: badgePrice
        });
    })));
});

export { PurchaseTypeSelectionBoxes };
//# sourceMappingURL=PurchaseTypeSelectionBoxes.js.map
